import {
  EtapaProjeto,
  ProjetoType,
  StatusEtapaResponseDTO,
} from 'models/projeto';
import { Options } from './ProjetosContext';

interface GenericAction<Type = string, Payload = any> {
  type: Type;
  payload: Payload;
}

export type ProjetosActionType =
  | GenericAction<'setContratoLoading', boolean>
  | GenericAction<'setProjeto', Partial<ProjetoType> & { dirty?: boolean }>
  | GenericAction<'setEtapa', EtapaProjeto>
  | GenericAction<'setOptionsLoading', { [k in keyof Options]?: boolean }>
  | GenericAction<
      'setOptions',
      { [k in keyof Options]?: Options[k]['options'] }
    >
  | GenericAction<
      'setStatusEtapa',
      { [k in EtapaProjeto]?: StatusEtapaResponseDTO }
    >
  | GenericAction<'setEtapaLoading', { [k in EtapaProjeto]?: boolean }>
  | GenericAction<'setSent', boolean>
  | GenericAction<'setDisabled', boolean>;

export interface ProjetosState {
  loading: boolean;
  projeto: Partial<ProjetoType>;
  etapa: EtapaProjeto;
  etapasLoading: { [k in EtapaProjeto]?: boolean };
  statusEtapas: { [k in EtapaProjeto]?: StatusEtapaResponseDTO };
  options: Options;
  dirty: boolean;
  sent: boolean;
  disabledFields: boolean;
}

export default function ProjetosReducer(
  state: ProjetosState,
  action: ProjetosActionType
): ProjetosState {
  const { type, payload } = action;
  switch (type) {
    case 'setSent':
      return { ...state, sent: payload };
    case 'setEtapa':
      return { ...state, etapa: payload, sent: false, dirty: false };
    case 'setProjeto':
      return {
        ...state,
        projeto: { ...state.projeto, ...payload },
        dirty: payload.dirty ?? true,
      };
    case 'setContratoLoading':
      return { ...state, loading: payload };
    case 'setStatusEtapa':
      return { ...state, statusEtapas: { ...state.statusEtapas, ...payload } };
    case 'setOptionsLoading':
      return {
        ...state,
        options: Object.entries(payload).reduce((ac, [key, value]) => {
          return {
            ...ac,
            [key]: {
              loading: value,
              options: state.options[key as keyof Options].options,
            },
          };
        }, state.options),
      };
    case 'setOptions':
      return {
        ...state,
        options: Object.entries(payload).reduce((ac, [key, value]) => {
          return {
            ...ac,
            [key]: {
              loading: state.options[key as keyof Options].loading,
              options: value,
            },
          };
        }, state.options),
      };
    case 'setEtapaLoading':
      return {
        ...state,
        etapasLoading: { ...state.etapasLoading, ...payload },
      };
    case 'setDisabled':
      return {
        ...state,
        disabledFields: payload,
      };
    default:
      return { ...state };
  }
}
